// extracted by mini-css-extract-plugin
export default {"checkAndLabel":"styles_checkAndLabel__Vup91"};